module.exports = __webpack_public_path__ + "img/ICBC.84f63a34.png";